
import Component, { mixins } from "vue-class-component";
import { Vue } from "vue-property-decorator";
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import { ProxyTableData } from '@/UI/components/Helpers/ProxyTableData';
import { SalaryCalculationsTable } from "@/UI/pages/SalaryСalculations/lib/table";
import { RouterNameEnum } from "@/router/router.types";

@Component({
    components: {
        PageTitle,
        BaseDataForm,
    }
})

export default class CosmetologCard extends mixins (ProxyTableData, SalaryCalculationsTable) {

    data: any = []

    goToLink() {
        Vue.router.push({
            name: RouterNameEnum.NewScheme,
            // params: {
            //     id: '1'
            // }
        })
    }

    async created() {
        this.formReady = true

        for(let i = 0; i < 20; i++) {
            this.data.push({
                key0: 'Администратор',
                key1: '0.00р',
                key2: '0р',
                key3: '800р/в день',
                key4: '',
                key5: '',
            })
        }
    }

}
